import { NavBar, Toast, Image, Grid, AutoCenter, Badge, Divider, Radio, Dialog, Space } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../../app/providers/AuthProvider';
import { authApi } from '../../features/auth/api/authApi';

export default function LevelAudit() {

    useEffect(() => {
        getGameDetail()
    }, []);

    const { memberInfo } = useAuth()

    const [userListInfo, setUserListInfo] = useState([])

    const getGameDetail = () => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        authApi.getAuditMembers()
            .then(function (response) {
                const detailData = response.data.data
                setUserListInfo(detailData)
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '服务错误！请联系管理员！'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }

    const userInfo = (level) => {
        const memberList = userListInfo?.filter(item => item?.level === level);

        // 将memberListData定义为数组
        const memberListData = [];

        memberList.forEach((user, index) => {
            if (!user.tempMember) {
                // 将JSX元素推入数组
                memberListData.push(
                    <Grid.Item key={index} style={{ padding: '5px' }}
                        onClick={() => {
                            let radioValue;
                            Dialog.confirm({
                                title: '修改' + (user.name) + '等级',
                                content:
                                    <div>
                                        <Radio.Group onChange={(value) => { radioValue = value }}>
                                            <Space>
                                                <Radio value='S' style={{ margin: '5px 0px' }}>
                                                    S
                                                </Radio>
                                                <Radio value='A' style={{ margin: '5px 0px' }}>
                                                    A
                                                </Radio>
                                                <Radio value='B' style={{ margin: '5px 0px' }}>
                                                    B
                                                </Radio>
                                                <Radio value='C' style={{ margin: '5px 0px' }}>
                                                    C
                                                </Radio>
                                                <Radio value='D' style={{ margin: '5px 0px' }}>
                                                    D
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>,
                                onConfirm: () => {
                                    if (!radioValue) {
                                        Toast.show({
                                            icon: 'fail',
                                            content: '请选择队员等级'
                                        })
                                    } else {
                                        const formData = new FormData();
                                        formData.append('memberId', user.id);
                                        formData.append('level', radioValue);
                                        formData.append('auditMemberId', memberInfo?.id)
                                        authApi.auditMemberLevel(formData).then((res) => {
                                            if (res.data.code === 200) {
                                                Toast.show({
                                                    icon: 'success',
                                                    content: '修改成功!',
                                                }
                                                )
                                            } else if (res.data.code === 500) {
                                                Toast.show({
                                                    icon: 'fail',
                                                    content: res.data.msg
                                                })
                                            }
                                            window.location.reload()
                                        })
                                    }
                                }
                            })
                        }}
                    >
                        <AutoCenter>
                            <Badge>
                                <Image
                                    src={user?.scMemberImageList[0]?.image + "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90"}
                                    width={50}
                                    height={50}
                                    fit='cover'
                                    style={{ borderRadius: '50%', border: '1px solid #ebeeef' }}
                                />
                            </Badge>
                        </AutoCenter>
                        <AutoCenter>
                            <span style={{ color: 'var(--text-main)' }}>
                                {user.name}
                            </span>

                        </AutoCenter>
                    </Grid.Item>
                );
            }
        });

        return (
            <Grid columns={5}>
                {memberListData}
            </Grid>
        );
    }

    return (
        <div className="auth-container has-unified-nav ui-page ui-page--with-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                球员等级管理
            </NavBar>
            <div className='info_detail ui-page__content'>
                <Divider>
                    <span style={{ color: 'var(--text-main)', fontWeight: "700", fontSize: "20px" }}>
                        S
                    </span>
                </Divider>
                {userInfo("S")}
                <Divider>
                    <span style={{ color: 'var(--text-main)', fontWeight: "700", fontSize: "20px" }}>
                        A
                    </span>
                </Divider>
                {userInfo("A")}
                <Divider>
                    <span style={{ color: 'var(--text-main)', fontWeight: "700", fontSize: "20px" }}>
                        B
                    </span>
                </Divider>
                {userInfo("B")}
                <Divider>
                    <span style={{ color: 'var(--text-main)', fontWeight: "700", fontSize: "20px" }}>
                        C
                    </span>
                </Divider>
                {userInfo("C")}
                <Divider>
                    <span style={{ color: 'var(--text-main)', fontWeight: "700", fontSize: "20px" }}>
                        D
                    </span>
                </Divider>
                {userInfo("D")}
            </div>
        </div>
    )
}
